<template>
  <div class="download-down">
    <div class="down-banner">
      <div class="content-main w1200">
        <p>下载知链助手</p>
      </div>
    </div>
    <div v-if="$store.state.sceneClassName === 'app'" class="download-down-app">
      <div class="down-item">
        <h1>移动端</h1>
        <div class="d-toast">
          <div class="t-content">
            <div class="c-name">讲师身份</div>
            <div class="c-type">
              <i class="el-icon-success"></i>
              <span>班课</span>
              <i class="el-icon-success"></i>
              <span>直播</span>
            </div>
          </div>
          <div class="t-content">
            <div class="c-name">学员身份</div>
            <div class="c-type">
              <i class="el-icon-success"></i>
              <span>班课</span>
              <i class="el-icon-error"></i>
              <span>直播</span>
            </div>
          </div>
        </div>
        <div class="d-btns">
          <a id="xe-down-android"
            ><button class="d-btn btn-blue">Android</button></a
          >
          <a id="xe-down-ios"><button class="d-btn btn-blue">iOS</button></a>
          <button class="d-btn btn-white">小程序</button>
        </div>
      </div>
      <div class="down-item">
        <h1>桌面端</h1>
        <div class="d-toast">
          <div class="t-content">
            <div class="c-name">讲师身份</div>
            <div class="c-type">
              <i class="el-icon-success"></i>
              <span>班课</span>
              <i class="el-icon-success"></i>
              <span>直播</span>
            </div>
          </div>
          <div class="t-content">
            <div class="c-name">学员身份</div>
            <div class="c-type">
              <i class="el-icon-success"></i>
              <span>班课</span>
              <i class="el-icon-success"></i>
              <span>直播</span>
            </div>
          </div>
        </div>
        <div class="d-btns">
          <a id="xe-client-windows" href="/"
            ><button class="d-btn btn-blue">Windows</button></a
          >
          <a id="xe-client-macos" href="/"
            ><button class="d-btn btn-blue">macOS</button></a
          >
          <button class="d-btn btn-white">OBS</button>
        </div>
      </div>
    </div>
    <div v-else class="down-download w1200">
      <div class="download download-PC">
        <div class="pc-bg">
          <img
            :src="require('@/assets/images/download8' + getImgSuffix + '.png')"
          />
        </div>
        <div class="common-info pc-info">
          <div class="info-title">桌面端</div>
          <div class="info-desc">
            <div class="info-choose d-top">
              <div class="info-toast">讲师身份</div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>班课</span>
              </div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>直播</span>
              </div>
            </div>
            <div class="info-choose d-bottom">
              <div class="info-toast">学员身份</div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>班课</span>
              </div>
              <div class="info-icon">
                <i class="el-icon-error"></i><span>直播</span>
              </div>
            </div>
          </div>
          <div class="info-group">
            <div class="info-btn">
              <a
                id="windos-btn"
                class="btn-download-link"
                target="_blank"
                href="/"
              >
                <div class="b-icon-container">
                  <div class="b-icon">
                    <i class="iconfont2 ico-windows info-i-windows"></i>
                  </div>
                  <div class="b-icon-hover info-hideicon">
                    <i class="iconfont2 ico-xiazai info-i-down"></i>
                  </div>
                </div>
                <div class="b-title b-title-change">
                  <span class="default-text">Windows</span>
                  <span class="hide-text">点击下载</span>
                </div>
              </a>
            </div>
            <div class="info-btn">
              <a
                id="mac-btn"
                class="btn-download-link"
                target="_blank"
                href="/"
              >
                <div class="b-icon-container">
                  <div class="b-icon">
                    <i class="iconfont2 ico-app-store-fill info-i-common"></i>
                  </div>
                  <div class="b-icon-hover info-hideicon">
                    <i class="iconfont2 ico-xiazai info-i-down"></i>
                  </div>
                </div>
                <div class="b-title b-title-change">
                  <span class="default-text">macOS</span>
                  <span class="hide-text">点击下载</span>
                </div>
              </a>
            </div>
            <div class="info-btn no-hover">
              <div class="b-icon no-hover">
                <i class="iconfont2 ico-obsstudio info-i-common"></i>
              </div>
              <div class="b-title">OBS-户外大型直播</div>
            </div>
          </div>
        </div>
      </div>
      <div class="download download-Mobile">
        <div class="common-info pc-info">
          <div class="info-title">移动端</div>
          <div class="info-desc">
            <div class="info-choose d-top">
              <div class="info-toast">讲师身份</div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>班课</span>
              </div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>直播</span>
              </div>
            </div>
            <div class="info-choose d-bottom">
              <div class="info-toast">学员身份</div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>班课</span>
              </div>
              <div class="info-icon">
                <i class="el-icon-success"></i><span>直播</span>
              </div>
            </div>
          </div>
          <div class="info-group">
            <div class="info-btn">
              <div class="b-m-icon-container">
                <div class="b-icon">
                  <i class="iconfont2 ico-ai-app info-i-android"></i>
                </div>
                <div class="b-qrcode">
                  <img :src="require('@/assets/images/qrcode@2x.png')" />
                </div>
                <div class="b-qrcode-main info-hideicon">
                  <img :src="require('@/assets/images/gzh_qrcode.png')" />
                </div>
              </div>
              <div class="b-title b-title-change">
                <span class="default-text">Android</span>
                <span class="hide-text">扫码下载</span>
              </div>
            </div>
            <div class="info-btn">
              <div class="b-m-icon-container">
                <div class="b-icon">
                  <i class="iconfont2 ico-ios info-i-ios"></i>
                </div>
                <div class="b-qrcode">
                  <img :src="require('@/assets/images/qrcode@2x.png')" />
                </div>
                <div class="b-qrcode-main info-hideicon">
                  <img :src="require('@/assets/images/gzh_qrcode.png')" />
                </div>
              </div>
              <div class="b-title b-title-change">
                <span class="default-text">iOS</span>
                <span class="hide-text">扫码下载</span>
              </div>
            </div>
            <div class="info-btn no-hover">
              <div class="b-icon">
                <i class="iconfont2 ico-xiaochengxu info-i-common"></i>
              </div>
              <div class="b-title">小程序开播</div>
            </div>
          </div>
        </div>
        <div class="mobile-bg">
          <img
            :src="require('@/assets/images/download8' + getImgSuffix + '.png')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getImgSuffix() {
      return this.$store.state.sceneClassName === 'app' ? '_app' : '';
    }
  }
};
</script>

<style lang="scss">
.download-down {
  .down-banner {
    background: url('~@/assets/images/download7.png') center no-repeat;
    background-size: cover;
    height: 640px;
  }
  .down-banner .content-main {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    height: 100%;
  }
  .down-banner .content-main p {
    font-size: 64px;
    font-weight: 500;
    color: #fff;
    line-height: 72px;
  }
  .down-download {
    color: #333;
    font-weight: 500;
  }
  .down-download .download {
    height: 554px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .down-download .download-PC .pc-bg img {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
    width: 568px;
  }
  .down-download .download-Mobile .mobile-bg img {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
    width: 595px;
  }
  .down-download .common-info .info-title {
    font-size: 44px;
    line-height: 52px;
  }
  .down-download .common-info .info-desc {
    margin-top: 24px;
  }
  .down-download .common-info .info-desc .info-choose {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .down-download .common-info .info-desc .info-choose:last-child {
    margin-top: 12px;
  }
  .down-download .common-info .info-desc .info-toast {
    font-weight: 400;
    line-height: 24px;
    padding-right: 16px;
  }
  .down-download .common-info .info-desc .info-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 16px;
  }
  .down-download .common-info .info-desc .info-icon i {
    display: block;
    font-size: 18px;
    color: #cccccc;
    &.el-icon-success {
      color: #1471ff;
    }
  }
  .down-download .common-info .info-desc .info-icon span {
    margin-left: 4px;
    font-weight: 400;
    line-height: 24px;
  }
  .down-download .common-info .info-group {
    margin-top: 56px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .down-download .common-info .info-group .info-hideicon {
    visibility: hidden;
  }
  .down-download .common-info .info-group .info-btn {
    margin-right: 36px;
  }
  .down-download .common-info .info-group .info-btn:not(.no-hover) {
    .hide-text {
      display: none;
    }
    &:hover {
      .b-qrcode,
      .b-icon {
        visibility: hidden;
      }
      .b-qrcode-main,
      .b-icon-hover {
        visibility: initial;
      }
      .b-title-change {
        .default-text {
          display: none;
        }
        .hide-text {
          display: inline;
        }
      }
    }
  }
  .down-download .common-info .info-group .info-btn .b-icon-container,
  .down-download .common-info .info-group .info-btn .b-m-icon-container {
    position: relative;
    cursor: pointer;
    .info-i-down {
      font-size: 48px;
      color: #1472ff;
    }
  }

  .down-download
    .common-info
    .info-group
    .info-btn
    .b-m-icon-container
    .b-qrcode {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
  }

  .down-download
    .common-info
    .info-group
    .info-btn
    .b-m-icon-container
    .b-qrcode
    img {
    display: block;
    width: 56px;
    height: 56px;
  }

  .down-download
    .common-info
    .info-group
    .info-btn
    .b-m-icon-container
    .b-qrcode-main {
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .down-download
    .common-info
    .info-group
    .info-btn
    .b-m-icon-container
    .b-qrcode-main
    img {
    display: block;
    width: 80px;
    height: 80px;
  }

  .down-download .common-info .info-group .info-btn .b-icon-hover {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .down-download .common-info .info-group .info-btn .b-icon-hover img {
    width: 52px;
    height: 46px;
    display: block;
  }

  .down-download .common-info .info-group .info-btn .b-icon {
    padding: 42px;
    background: #fff;
    -webkit-box-shadow: 0 0 16px 0 rgba(20, 114, 255, 0.08);
    box-shadow: 0 0 16px 0 rgba(20, 114, 255, 0.08);
    border-radius: 6px;
    .ico-ai-app {
      color: #8bc24a;
    }
    .ico-ios {
      color: #666666;
    }
    .ico-xiaochengxu,
    .ico-obsstudio {
      color: #999999;
    }
    .ico-obsstudio {
      position: relative;
      color: #ffffff;
      &::after {
        content: '';
        display: block;
        position: absolute;
        background: #999999;
        border-radius: 100%;
        width: 46px;
        height: 46px;
        top: 3px;
        left: 1px;
      }
      &::before {
        position: relative;
        z-index: 2;
      }
    }
  }

  .down-download .common-info .info-group .info-btn .b-icon i {
    display: block;
    font-size: 48px;
    color: #1472ff;
  }

  .down-download .common-info .info-group .info-btn .b-title {
    margin-top: 12px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
  }
}
.app .download-down {
  .down-banner {
    background: url('~@/assets/images/download7_app.png') center no-repeat;
    background-size: cover;
    color: #fff;
    height: 8.64rem;
    .content-main {
      display: block;
      p {
        padding-top: 2.44rem;
        font-size: 0.8rem;
        font-weight: 600;
        line-height: 0.96rem;
        text-align: center;
      }
    }
  }
  .down-item {
    color: #333;
    padding: 1.28rem 0.32rem 0;
    text-align: center;
  }
  .down-item h1 {
    font-size: 0.56rem;
    font-weight: 500;
    line-height: 0.72rem;
  }
  .down-item .d-toast {
    padding-bottom: 0.96rem;
  }
  .down-item .d-toast .c-type,
  .down-item .d-toast .t-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .down-item .d-toast .c-type {
    i {
      display: block;
      font-size: 0.36rem;
      margin-left: 0.32rem;
    }
    .el-icon-success {
      color: #1472ff;
    }
    .el-icon-error {
      color: #cccccc;
    }
  }
  .down-item .d-toast .t-content {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 0.32rem;
  }
  .down-item .d-toast .t-content .c-name,
  .down-item .d-toast .t-content span {
    font-weight: 400;
    line-height: 0.44rem;
    font-size: 0.28rem;
    margin-left: 0.06rem;
  }
  .down-item .d-toast .t-content img {
    display: block;
    width: 0.32rem;
    height: 0.32rem;
    margin-left: 0.32rem;
  }
  .down-item .d-toast .t-content .c-name {
    padding-right: 8px;
  }
  .down-item .d-btns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .down-item .d-btns .d-btn {
    line-height: 0.64rem;
    height: 0.64rem;
    width: 2.08rem;
    font-weight: 500;
    font-size: 0.28rem;
    border-radius: 0.32rem;
    text-align: center;
    border: none;
    outline: 0;
    -webkit-box-shadow: 0 0 0.32rem 0 rgba(20, 114, 255, 0.08);
    box-shadow: 0 0 0.32rem 0 rgba(20, 114, 255, 0.08);
    -webkit-transition: 0.2s all ease;
    transition: 0.2s all ease;
  }
  .down-item .d-btns .btn-blue {
    background-color: #1472ff;
    color: #fff;
  }
  .down-item .d-btns .btn-blue:active {
    background: #1159d6;
    color: #fff;
  }
  .down-item .d-btns .btn-white {
    background: #ccc;
    color: #fff;
  }
  .download-down-app {
    padding-bottom: 1.28rem;
  }
}
</style>
